
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';

@Component({})
export default class SPUAutoUpShelfDrawer extends Vue {
  @lazyInject(SPUService)
  spuService!: SPUService;

  @Ref()
  public readonly ruleForm!: FormModel;

  drawerVisible = false;

  moment = moment;

  shopId = 0;

  spuId = 0;

  autoOffShelfTime = '';

  form = {
    shouldUpShelf: false,
    autoUpShelfTime: '',
  };

  rules = {
    autoUpShelfTime: [],
  };

  @Watch('form', { deep: true })
  watchForm() {
    if (this.form.shouldUpShelf === true) {
      this.$set(this.rules, 'autoUpShelfTime', [...this.autoUpShelfTimeRule]);
    } else {
      this.$set(this.rules, 'autoUpShelfTime', []);
      this.form.autoUpShelfTime = '';
    }
  }

  /** 自动下架变更 */
  autoUpShelfTimeValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { autoUpShelfTime } = this.form;
    if (!autoUpShelfTime) {
      return true;
    }
    const duration = 60 * 10;
    const now = Math.round(Date.now() / 1000);
    const offShelfTime = Math.round(new Date(value).getTime() / 1000);
    if (offShelfTime - now < duration) {
      this.$message.error('自动上架时间至少设置在10分钟以后');
      return false;
    }
    return true;
  }

  autoUpShelfTimeRule = [
    { required: true, message: '自动上架时间不能为空', trigger: 'blur' },
    {
      validator: this.autoUpShelfTimeValidator,
      message: '自动上架时间至少设置在10分钟以后',
      trigger: 'blur',
    },
  ];

  onChangeAutoOffShelfTime(time: Moment, timeStr: string) {
    this.ruleForm.resetFields();

    const duration = 60 * 10;
    const now = Math.round(Date.now() / 1000);
    const offShelfTime = Math.round(new Date(timeStr).getTime() / 1000);
    console.log(offShelfTime, 'offShelfTime');
    console.log(now, 'now');
    if (offShelfTime - now < duration) {
      this.$message.error('自动上架时间至少设置在10分钟以后');
    }
    this.$set(this.form, 'autoUpShelfTime', timeStr);
  }

  open(value: any, shopId: number, spuId: number) {
    if (value.autoUpShelfTime) {
      this.form = {
        shouldUpShelf: true,
        autoUpShelfTime: value.autoUpShelfTime,
      };
    }
    this.shopId = shopId;
    this.spuId = spuId;
    this.autoOffShelfTime = value.autoOffShelfTime;
    this.drawerVisible = true;
  }

  onClose() {
    this.drawerVisible = false;
    this.reset();
  }

  reset() {
    this.spuId = 0;
    this.shopId = 0;
    this.form = {
      shouldUpShelf: false,
      autoUpShelfTime: '',
    };
  }

  async onOk() {
    this.ruleForm.validate(async (valid) => {
      if (valid) {
        console.log(this.form);
        const res = await this.spuService.setAutoOffShelfTime({
          spuId: this.spuId,
          autoUpShelfTime: this.form.autoUpShelfTime,
          autoOffShelfTime: this.autoOffShelfTime,
        });
        if (res) {
          this.$message.success(res);
          setTimeout(() => {
            this.onClose();
          }, 1500);
        }
      }
    });
  }
}
